export const StyleConfig = {
    imageSizeAuto: 'auto',
    imageSizeContain: 'contain',
    imageSizeCover: 'cover',
    imageSizeInitial: 'initial'
};